const IPCEngColor = [
    "White",
    "Blue-Grey",
    "Midnight Blue",
    "Blue",
    "Dark Blue",
    "Blue-Black",
    "Icy",
    "Pale",
    "Beige",
    "Golden",
    "Tan",
    "Light Brown",
    "Brown",
    "Dark Brown",
    "Obsidian",
    "Red",
    "Grey",
    "Black",
    "Ice",
    "Green",
    "Forest Green",
    "Dark Blue-Green",
    "Blue-Green",
    "Pale Green",
    "Purple",
    "Orange",
    "Gold",
    "Amber",
    "Dark Grey",
    "Light Yellow",
    "Yellow",
    "Dark Yellow",
    "Platinum",
    "Blonde",
    "Auburn",
    "Dark Red",
    "Marbled White",
    "Marbled Black"
];

const IPCEngRace = 
    [
    "Unitialized",
    "Elf",
    "Human",
    "Dwarf",
    "Orc"
];

const IPCEngSubrace = 
    [
    "Uninitialized",
    "Night Elf",
    "Wood Elf",
    "High Elf",
    "Sun Elf",
    "Dark Elf",

    "Uninitialized",
    "Mythical Human",
    "Nordic Human",
    "Eastern Human",
    "Coastal Human",
    "Southern Human",

    "Uninitialized",
    "Quarry Dwarf",
    "Mountain Dwarf",
    "Lumber Dwarf",
    "Hill Dwarf",
    "Volcano Dwarf",

    "Uninitialized",
    "Ash Orc",
    "Sand Orc",
    "Plains Orc",
    "Swamp Orc",
    "Blood Orc"
];

const IPCEngGender = 
[
    "Unitialized",
    "Female",
    "Male",
    "Non-Binary"
];

const IPCEngHandedness = 
[
    "Unitialized",
    "Left",
    "Right"
];

const IPCEng = {
    Color: IPCEngColor,
    Race: IPCEngRace,
    Subrace: IPCEngSubrace,
    Gender: IPCEngGender,
    Handedness: IPCEngHandedness
};

export default IPCEng;
